import { MovementProgressTopDescriptionType } from '@services/movement-progress/movement-progress.constants';
import { IMovementFlowSummarySection } from './movement-flow';
import { IDocumentDeleteToasts } from './movements';

export enum MovementInfoType {
  DEPOSIT = 'deposit_undistributed',
  PORTFOLIOS_DEPOSIT = 'portfolios_deposit',
  PORTFOLIOS_WITHDRAWAL = 'portfolios_withdrawal',
  STOCKS_USD_DEPOSIT = 'stocks_usd_deposit',
  STOCKS_USD_WITHDRAWAL = 'stocks_usd_withdrawal',
  STOCKS_BUY_DEPOSIT = 'stocks_buy_deposit',
  STOCKS_BUY = 'stocks_buy',
  STOCKS_SELL = 'stocks_sell',
  PORTFOLIOS_TO_STOCKS_WITHDRAWAL = 'portfolios_to_stocks_withdrawal',
  PORTFOLIOS_TO_STOCKS_DEPOSIT = 'portfolios_to_stocks_deposit',
  STOCKS_TO_PORTFOLIOS_WITHDRAWAL = 'stocks_to_portfolios_withdrawal',
  STOCKS_TO_PORTFOLIOS_DEPOSIT = 'stocks_to_portfolios_deposit',
  BETWEEN_PORTFOLIOS_WITHDRAWAL = 'between_portfolios_withdrawal',
  BETWEEN_PORTFOLIOS_DEPOSIT = 'between_portfolios_deposit',
}

export const TYPES_WITH_DISTRIBUTION = [
  MovementInfoType.PORTFOLIOS_DEPOSIT,
  MovementInfoType.PORTFOLIOS_WITHDRAWAL,
  MovementInfoType.PORTFOLIOS_TO_STOCKS_WITHDRAWAL,
  MovementInfoType.STOCKS_TO_PORTFOLIOS_DEPOSIT,
  MovementInfoType.BETWEEN_PORTFOLIOS_WITHDRAWAL,
  MovementInfoType.BETWEEN_PORTFOLIOS_DEPOSIT,
];

export const TYPES_WITH_FX_INFORMATION = [
  MovementInfoType.STOCKS_USD_DEPOSIT,
  MovementInfoType.STOCKS_USD_WITHDRAWAL,
  MovementInfoType.STOCKS_BUY_DEPOSIT,
  MovementInfoType.PORTFOLIOS_TO_STOCKS_DEPOSIT,
  MovementInfoType.STOCKS_TO_PORTFOLIOS_WITHDRAWAL,
];

export const TYPES_WITH_DW_COLORS = [
  ...TYPES_WITH_FX_INFORMATION,
  MovementInfoType.STOCKS_BUY,
  MovementInfoType.STOCKS_SELL,
];

export interface IProgressInfo {
  progressComponent: IMovementInfoProgressSection;
  topDescription?: IMovementInfoTopDescription;
  canBeCancelled?: boolean;
  cancelText?: string;
  cancelConfirmationText?: string;
}

export interface IMovementInfoTopDescription {
  type: MovementProgressTopDescriptionType;
  attributes: any;
}

export interface IMovementInfoProgressStep {
  label: string[];
  date?: string;
  isCompleted: boolean;
}

export interface IMovementInfoProgressSection {
  title: string;
  steps: IMovementInfoProgressStep[];
}

export enum FxSide {
  BUYING = 'buying',
  SELLING = 'selling',
}

export interface IMovementInfoFxInformation {
  side: FxSide;
  amount: number;
  amountUSD: number;
  executed: boolean;
  usdPrice?: number;
}

export interface IPortfoliosDistributionItem {
  name: string;
  executedAmount?: number;
  percentage: number;
}

export interface IPortfoliosDistribution {
  title: string;
  portfolios: IPortfoliosDistributionItem[];
}

export interface IMovementInfoBottomMessage {
  type: MovementInfoType;
  attributes: any;
}

export interface IMovementInfo {
  type: MovementInfoType;
  title?: string;
  topDescription?: IMovementInfoTopDescription;
  progressSection?: IMovementInfoProgressSection;
  fxInformation?: IMovementInfoFxInformation;
  portfoliosDistribution?: IPortfoliosDistribution;
  assetsSection?: IMovementFlowSummarySection;
  bottomMessage?: IMovementInfoBottomMessage;
  cancelText?: string;
  cancelConfirmationText?: string;
  useDWColors?: boolean;
}

export enum MovementInfoTypeCollection {
  WITHDRAWAL = 'withdrawals',
  ORDER = 'orders',
  DEPOSIT = 'deposits',
  KIPHU_TRANSFER = 'kiphuTransfers',
}

export const mapMovementInfoTypeToSuccessDeleteToast = {
  [MovementInfoType.PORTFOLIOS_TO_STOCKS_WITHDRAWAL]: IDocumentDeleteToasts.portfolioTransfer,
};

export const mapMovementInfoTypeToErrorDeleteToast = {
  [MovementInfoType.PORTFOLIOS_TO_STOCKS_WITHDRAWAL]: IDocumentDeleteToasts.portfolioTransferError,
};
